import { Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { showAddProjectModal } from '../../actions/organization'
import AddProject from '../Organization/AddProject'
import { RootState } from '../../store'
import { createSelector } from '@reduxjs/toolkit'
import { AddNewProjectIcon } from '../Svgs'

interface StartNewProjectProps {}

const isShowAddProjectModalSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.showAddProjectModal,
)
const selectedClientSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedClient,
)
const selectedOrganizationSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedOrganization,
)

const StartNewProjectComponent: React.FC<StartNewProjectProps> = ({}) => {
  const dispatch = useDispatch<any>()
  const isShowAddProjectModal = useSelector(isShowAddProjectModalSelector)
  const selectedClient = useSelector(selectedClientSelector)
  const selectedOrganization = useSelector(selectedOrganizationSelector)

  return (
    <>
      <Button
        disableRipple
        onClick={() => dispatch(showAddProjectModal(true))}
        sx={{
          background: '#E5F0FF',
          borderRadius: '0.4rem',
          width: '100%',
          height: '100%',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          boxSizing: 'border-box',
          gap: '1rem',
          p: '0.75rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '0.4rem',
            boxShadow: '0px 1px 5px 0px #00000040',
            background: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 'normal',
          }}
        >
          <AddNewProjectIcon color={'#1705E5'} />
        </Box>
      </Button>
      <AddProject
        isOpen={isShowAddProjectModal}
        handleClose={() => dispatch(showAddProjectModal(false))}
        selectedClient={selectedClient}
        selectedOrganization={selectedOrganization}
      ></AddProject>
    </>
  )
}

export default StartNewProjectComponent
